"use client";

import { Button } from "@/components/ui/Button";
import { H1, H3 } from "@/components/ui/Heading";
import { gTagEvents } from "@/lib/gtag";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useEffect } from "react";
import { useIntersectionObserver } from "usehooks-ts";

export const PocketListingSection = () => {
  const t = useTranslations("home.private-collection");

  const { ref, isIntersecting } = useIntersectionObserver({
    threshold: 0.9,
    freezeOnceVisible: true,
  });

  useEffect(() => {
    if (isIntersecting) {
      gTagEvents.viewPromotion({
        creative_name: "Sakani Private Collection",
        creative_slot: "0",
        promotion_id: "Sakani Private Collection",
        promotion_name: "Sakani Private Collection",
      });
    }
  }, [isIntersecting]);

  return (
    <section
      className="py-2.5 px-1.5 sm:px-20 sm:py-24 relative bg-black w-full"
      ref={ref}
    >
      <Image
        fill
        src="bcd498f6-41aa-4cd4-95ce-69fb11525100"
        alt="private-collection"
        priority
        rel="preload"
        loading="eager"
        fetchPriority="high"
        sizes="(max-width: 768px) 30vw, 90vw"
      />
      <div className="text-center sm:text-left w-full flex gap-10 flex-col sm:flex-row rounded-md justify-center relative items-center">
        <div className="p-2 sm:p-10 flex flex-col gap-5 sm:gap-10 sm:items-start items-center w-full">
          <div className="space-y-2">
            <H1 as="h2" className="!text-[#9B9692] !font-normal !text-2xl">
              {t("title").toUpperCase()}
            </H1>
          </div>

          <div className="text-gray-200 space-y-2.5">
            <H3 as={"p"} className="!text-gray-200 !font-normal">
              {t("description")}
            </H3>
          </div>

          <Button disabled className="bg-[#9B9692] max-w-fit h-12 min-w-20">
            {t("cta")}
          </Button>
        </div>

        <div className="relative h-full w-[310px] sm:h-[239px] sm:w-[410px] ">
          <Image
            fill
            alt="Pocket listing"
            src="0bb7014f-3142-4d93-f493-f365dd3a5900"
            className="object-contain"
          />
        </div>
      </div>
    </section>
  );
};
